/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* The method to use for restoring the DynamoDB table.
*/
export enum RestoreMethod {
  RESTORE_METHOD_UNSPECIFIED = 'RESTORE_METHOD_UNSPECIFIED',
  RESTORE_METHOD_AUTO = 'RESTORE_METHOD_AUTO',
  RESTORE_METHOD_IMPORT_TABLE = 'RESTORE_METHOD_IMPORT_TABLE',
  RESTORE_METHOD_CAPACITY_BASED = 'RESTORE_METHOD_CAPACITY_BASED'
}
